// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__4FlkG","overflowing":"ReadFullNote_overflowing__x1icn"};